import React, { useEffect, useState } from 'react';
import { CalenderIcon } from '../../Assets/Icons';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import CustomDateRangePicker from '../DateRangePicker';
import { convertStringToISODate } from '../../Utils/general';
import { setUpdateResource } from '../../Store/slice/subscriptionSlice';

const ResourceList = () => {
    const dispatch = useDispatch();
    const { checkedResource, dateRange } = useSelector(state => state.subscriptionSlice);
    const [list, setList] = useState([]);

    useEffect(() => {
        setList(checkedResource);
    }, [checkedResource, dateRange]);

    const handleUpdateDateRange = (dates, id) => {
        let resource = list.map((item) => ({
            ...item,
            dates: item.id === id ? dates ? dates : [null, null] : item.dates
        }));
        dispatch(setUpdateResource({ data: resource }));
    }


    return (
        <>
            <h5>XR Module</h5>
            <p>Select the XR Module you want to assign to a group, user, and role</p>

            {list.map((item) => {
                return (
                    <div className="validity-application-list">
                        <div className="validitythumb">
                            <div className="modulethumb">
                                <img src={item.icon} alt="" />
                            </div>
                            <div>
                                <h5> {item.title} </h5>
                            </div>
                        </div>
                        <CustomDateRangePicker dateRange={[convertStringToISODate(item.dates[0]), convertStringToISODate(item.dates[1])]} setDateRange={(data) => handleUpdateDateRange(data, item.id)} />
                    </div>
                )
            })}

        </>
    )
}

export default ResourceList